import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  range?: string
}

const WidgetHeader = ({ title, range }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" gap="s2" justifyContent="spaceBetween">
        <Text color="grey800" size="200" weight="medium" ellipsis whiteSpace="nowrap">
          {title}
        </Text>
        <Box alignSelf="center" paddingTop="s2">
          <Icon.Small color="grey700" icon="arrow-right" />
        </Box>
      </Box>
      <Box alignItems="flexStart">
        <Text color="grey800" size="100" weight="normal" ellipsis whiteSpace="nowrap">
          {range}
        </Text>
      </Box>
    </Box>
  )
}

export default WidgetHeader
